import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";
import { useEffect } from "react";
import StateInterface from "../../../redux-magic/state-interface";
import { setBroadcastFormThunk } from "../../../redux-magic/store";

// Styled components
const Container = styled("div")({
    display: "flex",
    width: "100vw",
    flexDirection: "column",
    alignItems: "center",
    // position: "relative",
    // minHeight: "100vh",
    backgroundImage: "url('/images/broadcast/BuildingBackground.svg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    flex: 1
});

const TipBar = styled("div")({
    width: "100vw",
    height: "36px",
    gap: "8px",
    paddingRight: "16px",
    paddingLeft: "16px",
    background: "#FFC400",
    display: "flex",
    alignItems:"center",
    boxSizing: "border-box",
    paddingTop: 0,
    paddingBottom: 0,
});

const TipTypography = styled(Typography)({
    fontWeight: "500",
    fontSize: "10px",
    lineHeight: "14px",
    letterSpacing: "0px",
    color:"black"
})

const InfoIcon = styled(InfoOutlined)({
    width: "16px",
    height: "16px",
})

const Heading = styled(Typography)({
    lineHeight: "133%",
    letterSpacing: "0px",
    fontWeight: 700,
    textAlign: "center",
    marginTop: "48px",
});

const Percent = styled(Typography)({
    fontWeight: "700",
    lineHeight: "112.03px",
    letterSpacing: "-12.5px",
    textAlign: "center",
    color: "#5B5B5B",
    marginTop:"120px"
});

const Content = styled("div")({
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

const RangeSlider = styled(Slider)({
    width: "80%",
    height: "5px",
    marginTop:"145px",
})


export default function Commission(
    {
        dispatch,
        broadcast,
        transactionType,
    }:
    {
      dispatch: Function;
      broadcast:  StateInterface["broadcast_data"] | undefined | null;
      transactionType: string;
}) {

    useEffect(() => {
        if(!broadcast?.commission_offered || broadcast?.commission_offered === 0) dispatch(setBroadcastFormThunk({commission_offered: transactionType==='buy'? 5: 30, no_of_agents: broadcast?.no_of_agents || 0, notes: broadcast?.notes || ""}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  let comissionType = "%";
  let defaultCommissionValue = broadcast?.commission_offered || 5;
  let minCommissionValue = 2;
  let maxCommissionValue = 30;
  if (transactionType !== "buy") {
    comissionType = "days";
    defaultCommissionValue = broadcast?.commission_offered || 30;
    minCommissionValue = 10;
    maxCommissionValue = 60;
  }

  return (
    <Container>
      <TipBar>
        <InfoIcon/>
        <TipTypography>Tip : Commision are the main part in the process try to gime at max commission that oth parties can agreen</TipTypography>
      </TipBar>
        <Content>
          <Heading variant="h5">Commision you can offer</Heading>
          <Percent variant="h1">{broadcast?.commission_offered} {comissionType}</Percent>
          <RangeSlider
            onChange={async (_event, value) => {
                const numValue = Array.isArray(value) ? value[0] : value;
                await dispatch(setBroadcastFormThunk({
                  commission_offered: numValue || 0,
                  no_of_agents: broadcast?.no_of_agents || 0,
                  notes: broadcast?.notes || ""
                }));
            }}
            sx={{
              "& .MuiSlider-track": {
                color: "#621B16",
              },
              "& .MuiSlider-thumb": {
                color: "#621B16",
              },
              "& .MuiSlider-rail":{
                color: "#828282",
              }
            }}
            defaultValue={defaultCommissionValue}
            min={minCommissionValue}
            max={maxCommissionValue}
          />
        </Content>
    </Container>
  );
}
